import { render, staticRenderFns } from "./PluginDialog.vue?vue&type=template&id=30fd918e&"
import script from "./PluginDialog.vue?vue&type=script&lang=js&"
export * from "./PluginDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fd918e')) {
      api.createRecord('30fd918e', component.options)
    } else {
      api.reload('30fd918e', component.options)
    }
    module.hot.accept("./PluginDialog.vue?vue&type=template&id=30fd918e&", function () {
      api.rerender('30fd918e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/PluginDialog.vue"
export default component.exports